// extracted by mini-css-extract-plugin
module.exports = {"promoTag":"styles_promoTag__AJP8l","labelWrapper":"styles_labelWrapper__Wm_VV"};